export const projectConfig = {
  port: 4600,
  host: 'localhost',
};
